import { render, staticRenderFns } from "./NoticeHeader.vue?vue&type=template&id=1f4d7d54"
import script from "./NoticeHeader.vue?vue&type=script&lang=js"
export * from "./NoticeHeader.vue?vue&type=script&lang=js"
import style0 from "./NoticeHeader.vue?vue&type=style&index=0&id=1f4d7d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports